let promise = null;

export function loadGoogleMaps(apiKey) {
  if (typeof window !== "undefined" && window.google?.maps) {
    return Promise.resolve(window.google.maps);
  }
  if (promise) return promise;

  promise = new Promise((resolve, reject) => {
    const cb = "__gmapsInitCb";
    window[cb] = () => resolve(window.google.maps);
    const s = document.createElement("script");
    s.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&loading=async&callback=${cb}`;
    s.async = true;
    s.defer = true;
    s.onerror = () => {
      promise = null;
      reject(new Error("Failed to load Google Maps"));
    };
    document.head.appendChild(s);
  });
  return promise;
}
